module.exports = __webpack_public_path__ + "static/appDemo03-de04b746847a4126cc13a59703e0feae.png";